// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import * as rectLib from '../../../../common/maths/geometry/rect';

// Styles
import './LineEdgeSnapPointGuide.scss';

const LineEdgeSnapPointGuide = (props) => {
    const { snapPoints, dropPosition } = props;

    if (!snapPoints || !dropPosition) return null;

    return (
        <>
            {snapPoints.map((snapPoint, index) => {
                const opacity = rectLib.containsPoint(snapPoint.visibleRect, dropPosition) ? 1 : 0;

                const pointStyle = {
                    top: snapPoint.point.y,
                    left: snapPoint.point.x,
                    width: snapPoint.radius * 2,
                    height: snapPoint.radius * 2,
                    opacity,
                };
                return (
                    <div key={index} className="LineEdgeSnapPointGuide" style={pointStyle}>
                        <div className="guide-ring" />
                    </div>
                );
            })}
        </>
    );
};

LineEdgeSnapPointGuide.propTypes = {
    snapPoints: PropTypes.array,
    dropPosition: PropTypes.object,
};

export default LineEdgeSnapPointGuide;
